<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Open Space Technology</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="dedication">
<a id="pagev">
<p><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center" id="d7e2786"><i>To all the people from all over the world </i><br/><i>who have joined me in the cocreation of Open Space </i><br/><i>–thank you for the journey!</i></p>
</a></div><a id="pagev">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?f4d71796